import React, { Component, useState, Suspense } from 'react'
import ServerRoutes from './routes/ServerRouter';
import { Provider } from 'react-redux';
//import configureStore from './skins/demoskin1/store'
import Components from './ComponentIndex';


function ServerApp(props) {
    var skin=props.skin
    const configureStore = Components[skin+"_ConfigureStore"]
    const store = configureStore(props.jsonContent);
    return (
        <>
            <Provider store={store}>
                <ServerRoutes skin={skin}></ServerRoutes>
            </Provider>

        </>
    )
}

export default ServerApp